import App from './App.vue';

export default {
  path: '/CDS_VF_PublicityList',
  name: 'CDS_VF_PublicityList',
  component: App,
  meta: {
    pageProperty: {
      title: '市民への情報提供履歴',
      controller: 'CDS_CTR_PublicityList',
    },
  },
};
